












import { defineComponent } from "@vue/composition-api";
import { Route } from "vue-router";
import { EVENT_NAMES } from "@scrile/api-provider/dist";
import emitter from "@/lib/emitter";
import { Notification } from "@/types";
import { EVENTS } from "@/const";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "StatusNotificationBar",
  components: { BaseIcon },
  data() {
    return {
      notificationList: [] as Notification[],
      show: false,
    };
  },
  watch: {
    $route(to: Route, from: Route) {
      if (to.path !== from.path) {
        this.clearNotifications();
      }
    },
  },
  methods: {
    addNotification(text: string, type: "error" = "error") {
      const notification: Notification = {
        text,
        type,
      };
      const exist = this.notificationList.findIndex(item => item.text === text) > -1;
      if (exist) return;
      this.notificationList = [...this.notificationList, notification];
      this.show = true;
    },

    clearNotifications() {
      this.notificationList = [];
    },

    showNotificationHandler({ text, type }: Notification) {
      this.addNotification(text, type);
    },

    requestStatusHandler({ status, message }: { status: string; message: string }) {
      if (status === "error") this.addNotification(message, status);
    },
  },
  mounted() {
    emitter.on<any>(EVENTS.STATUS_SHOW, this.showNotificationHandler);
    emitter.on<any>(EVENTS.STATUS_HIDE, this.clearNotifications);
    emitter.on<any>(EVENT_NAMES.REQUEST_STATUS, this.requestStatusHandler);
  },
  beforeDestroy() {
    emitter.off<any>(EVENTS.STATUS_SHOW, this.showNotificationHandler);
    emitter.off<any>(EVENTS.STATUS_HIDE, this.clearNotifications);
    emitter.off<any>(EVENT_NAMES.REQUEST_STATUS, this.requestStatusHandler);
  },
});
